import { Route } from '@angular/router';

export const I18nRoutes: Route[] = [
  {
    path: 'i18n',
    loadComponent: () => import('../pages/i18n/i18n.page'),
  },
];
